(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belvoir-hero"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('belvoir-hero'))customElements.define('belvoir-hero',class extends HTMLElement{
connectedCallback(){
this.slides=[...this.querySelectorAll('[data-slide]')];if(this.slides.length<2)return;
this.abort=new AbortController();const options={signal:this.abort.signal};this.index=0;this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;
this.controls=this.querySelector('.bv-hero-controls');this.controls.hidden=false;this.pause=this.querySelector('[data-pause]');const dots=this.querySelector('[data-dots]');dots.replaceChildren();
this.dots=this.slides.map((slide,index)=>{const b=document.createElement('button');b.type='button';b.dataset.dot='';b.setAttribute('aria-label',slide.querySelector('h1,h2')?.textContent||String(index+1));b.addEventListener('click',()=>{this.show(index);this.schedule()},options);dots.append(b);return b});
this.pause.addEventListener('click',()=>{this.paused=!this.paused;this.updatePause();this.schedule()},options);
this.addEventListener('focusin',()=>clearTimeout(this.timer),options);this.addEventListener('focusout',()=>setTimeout(()=>this.schedule(),0),options);
this.addEventListener('touchstart',e=>{this.startX=e.touches[0].clientX;this.startY=e.touches[0].clientY;clearTimeout(this.timer)},{...options,passive:true});
this.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-this.startX,dy=e.changedTouches[0].clientY-this.startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));this.schedule()},{...options,passive:true});
this.addEventListener('touchcancel',()=>this.schedule(),options);
document.addEventListener('visibilitychange',()=>this.schedule(),options);
this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.editorSelected=true;this.show(i);clearTimeout(this.timer)}},options);
this.addEventListener('shopify:block:deselect',()=>{this.editorSelected=false;this.schedule()},options);
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()},{threshold:.2});this.observer.observe(this);this.show(0);this.updatePause();
}
show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>{const active=n===this.index;s.classList.toggle('is-active',active);s.inert=!active;s.setAttribute('aria-hidden',String(!active));this.dots[n].setAttribute('aria-current',String(active))})}
updatePause(){this.pause.textContent=this.paused?'▷':'Ⅱ';this.pause.setAttribute('aria-label',this.paused?this.pause.dataset.playLabel:this.pause.dataset.pauseLabel)}
schedule(){clearTimeout(this.timer);if(this.paused||!this.visible||document.hidden||this.editorSelected||this.matches(':focus-within'))return;const seconds=Number(this.slides[this.index]?.dataset.duration)||0;const interval=seconds>0?Math.min(60000,Math.max(1000,seconds*1000)):(Number(this.dataset.interval)||6000);this.timer=setTimeout(()=>{this.show(this.index+1);this.schedule()},interval)}
disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect()}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belvoir-reference-social"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('belvoir-family')){
  customElements.define('belvoir-family',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.track=this.querySelector('.bv-family__track');
      this.group=document.createElement('div');this.group.className='bv-family__group';
      this.group.append(...this.track.children);this.track.append(this.group);
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.reduced.matches;this.visible=false;this.dragging=false;this.linkFocused=false;
      this.manual=false;this.touching=false;this.userPaused=false;this.dialogOpen=false;
      this.touchOrigin=null;this.touchMoved=false;
      const resumeButton=this.querySelector('[data-family-resume]');
      const resumeRow=this.querySelector('[data-family-resume-row]');
      const setResumeVisible=(shouldShow)=>{
        if(resumeButton)resumeButton.hidden=!shouldShow;
        if(resumeRow)resumeRow.hidden=!shouldShow;
      };
      setResumeVisible(false);
      const pauseMobileAutoplay=()=>{
        if(window.innerWidth>=750||this.dataset.stopMobileAfterSwipe!=='true')return;
        this.userPaused=true;this.last=0;this.dataset.manualPaused='true';
        setResumeVisible(true);
      };
      // REPRENDRE must clear every transient block, not just userPaused.
      // Otherwise a previous drag, popup focus or Theme Editor selection may
      // leave the RAF auto-scroll loop paused on both Home and Product pages.
      const resumeAutoScroll=()=>{
        clearTimeout(this.resumeTimer);
        this.userPaused=false;
        this.manual=false;
        this.touching=false;
        this.dragging=false;
        this.mouseStartX=null;
        this.mouseDragged=false;
        this.linkFocused=false;
        this.hoverPaused=false;
        this.paused=this.reduced.matches;
        this.dialogOpen=!!this.querySelector('[data-family-post-dialog][open]');
        this.last=0;
        if(!this.width){
          this.layout();
        }
        const range=this.width||this.group?.getBoundingClientRect().width||0;
        this.offset=range?(this.track.scrollLeft%range):this.track.scrollLeft;
        delete this.dataset.manualPaused;
        setResumeVisible(false);
      };
      resumeButton?.addEventListener('click',event=>{
        event.preventDefault();
        event.stopPropagation();
        resumeAutoScroll();
      },options);
      const passive={...options,passive:true};
      this.arrows=[this.querySelector('[data-bv-family-prev]'),this.querySelector('[data-bv-family-next]')];
      const move=direction=>{
        pauseMobileAutoplay();
        this.manual=true;
        this.offset=this.track.scrollLeft;
        this.track.scrollBy({left:direction*this.track.clientWidth*.7,behavior:this.reduced.matches?'auto':'smooth'});
        clearTimeout(this.resumeTimer);
        this.resumeTimer=setTimeout(()=>{this.offset=this.track.scrollLeft;this.manual=false;this.last=0},1600);
      };
      this.arrows[0]?.addEventListener('click',()=>move(-1),options);
      this.arrows[1]?.addEventListener('click',()=>move(1),options);
      this.addEventListener('mouseenter',()=>{this.hoverPaused=true},options);
      this.addEventListener('mouseleave',()=>{this.hoverPaused=false},options);
      this.hoverPaused=false;
      const begin=()=>{clearTimeout(this.resumeTimer);this.manual=true;this.offset=this.track.scrollLeft};
      const settle=()=>{
        clearTimeout(this.resumeTimer);
        if(this.touching||this.dragging)return;
        this.resumeTimer=setTimeout(()=>{this.offset=this.track.scrollLeft;this.manual=false;this.last=0},300);
      };
      this.track.addEventListener('touchstart',event=>{
        this.touching=true;
        const touch=event.touches[0];
        this.touchOrigin=touch?{x:touch.clientX,y:touch.clientY}:null;
        this.touchMoved=false;
        begin();
      },passive);
      this.track.addEventListener('touchmove',event=>{
        const touch=event.touches[0];
        if(!touch||!this.touchOrigin||this.touchMoved)return;
        const dx=touch.clientX-this.touchOrigin.x;
        const dy=touch.clientY-this.touchOrigin.y;
        if(Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy)*1.1){
          this.touchMoved=true;
          pauseMobileAutoplay();
        }
      },passive);
      const endTouch=event=>{
        this.touching=event.touches.length>0;
        if(!this.touching){this.dragging=false;this.touchOrigin=null;settle()}
      };
      window.addEventListener('touchend',endTouch,passive);
      window.addEventListener('touchcancel',endTouch,passive);
      this.track.addEventListener('pointerdown',event=>{
        this.dragging=true;begin();
        if(event.pointerType==='mouse'&&this.dataset.dragDesktop==='true'){
          this.mouseStartX=event.clientX;this.mouseStartScroll=this.track.scrollLeft;this.mouseDragged=false;
        }else{this.mouseStartX=null}
      },passive);
      this.track.addEventListener('pointermove',event=>{
        if(this.mouseStartX==null||!this.dragging)return;
        const delta=event.clientX-this.mouseStartX;
        if(Math.abs(delta)>5){this.mouseDragged=true;this.track.scrollLeft=this.mouseStartScroll-delta}
      },passive);
      this.track.addEventListener('click',event=>{
        if(this.mouseDragged){event.preventDefault();event.stopPropagation();this.mouseDragged=false}
      },{...options,capture:true});
      const endPointer=()=>{this.dragging=false;this.mouseStartX=null;settle()};
      window.addEventListener('pointerup',endPointer,passive);
      window.addEventListener('pointercancel',endPointer,passive);
      this.track.addEventListener('scroll',()=>{
        if(this.manual||this.userPaused){this.offset=this.track.scrollLeft;if(this.manual)settle()}
      },passive);
      this.track.addEventListener('wheel',()=>{begin();settle()},passive);
      this.track.addEventListener('focusin',()=>this.linkFocused=true,options);
      this.track.addEventListener('focusout',event=>{
        if(!this.track.contains(event.relatedTarget)){
          this.linkFocused=false;
          this.offset=this.track.scrollLeft;
        }
      },options);
      // Dialogs live OUTSIDE the looping gallery so cloned cards never duplicate modal IDs.
      this.addEventListener('click',event=>{
        const open=event.target.closest('[data-family-post-open]');
        if(open){
          event.preventDefault();
          const dialog=this.querySelector('#'+CSS.escape(open.dataset.familyPostOpen||''));
          if(!dialog||dialog.open)return;
          this.dialogOpen=true;this.last=0;this.dialogReturnFocus=open;
          dialog.showModal();
          dialog.querySelector('[data-family-post-close]')?.focus({preventScroll:true});
          if(!this.reduced.matches){
            dialog.querySelectorAll('video').forEach(video=>video.play().catch(()=>{}));
          }
          return;
        }
        const close=event.target.closest('[data-family-post-close]');
        if(close){
          const dialog=close.closest('dialog');
          if(dialog?.open)dialog.close();
        }
      },options);
      this.querySelectorAll('[data-family-post-dialog]').forEach(dialog=>{
        dialog.addEventListener('close',()=>{
          this.dialogOpen=false;this.last=0;
          dialog.querySelectorAll('video').forEach(video=>video.pause());
          if(this.dialogReturnFocus?.isConnected)this.dialogReturnFocus.focus({preventScroll:true});
          this.dialogReturnFocus=null;
        },options);
        dialog.addEventListener('click',event=>{
          if(event.target!==dialog)return;
          const bounds=dialog.getBoundingClientRect();
          if(event.clientX<bounds.left||event.clientX>bounds.right||
             event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
        },options);
      });
      this.addEventListener('shopify:block:select',event=>{
        this.paused=true;
        if(event.target?.scrollIntoView)event.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      },options);
      this.addEventListener('shopify:block:deselect',()=>{this.paused=this.reduced.matches;this.last=0},options);
      this.resize=new ResizeObserver(()=>this.layout());this.resize.observe(this.track);this.layout();
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.last=0});this.observer.observe(this);
      const tick=time=>{const elapsed=this.last?Math.min(time-this.last,50):0;this.last=time;
        if(this.visible&&!document.hidden&&this.dataset.autoplay==='true'&&!this.paused&&!this.userPaused&&!this.dialogOpen&&!this.manual&&!this.dragging&&!this.linkFocused&&!(this.hoverPaused&&this.dataset.pauseHover==='true')&&this.width){
          this.offset=(this.offset+elapsed*(Number(this.dataset.speed)||35)/1000)%this.width;this.track.scrollLeft=this.offset;
        }
        this.frame=requestAnimationFrame(tick);
      };this.frame=requestAnimationFrame(tick);
    }
    layout(){
      this.track.querySelectorAll('[data-family-copy]').forEach(node=>node.remove());
      const isMobile=window.innerWidth<750;
      const rawSize=Number(isMobile?this.dataset.mobileWidth:this.dataset.desktopWidth);
      const fraction=Math.min(95,Math.max(15,rawSize||(isMobile?72:22)))/100;
      this.style.setProperty('--family-card-width',(this.track.clientWidth*fraction)+'px');
      this.width=this.group.getBoundingClientRect().width;if(!this.width)return;
      const copies=Math.ceil(this.track.clientWidth/this.width)+1;
      for(let i=0;i<copies;i++){
        const copy=this.group.cloneNode(true);
        copy.dataset.familyCopy='';copy.setAttribute('aria-hidden','true');
        copy.querySelectorAll('*').forEach(node=>{
          node.removeAttribute('id');
          node.removeAttribute('data-shopify-editor-block');
          for(const name of [...node.getAttributeNames()]){
            if(name.startsWith('data-shopify-editor-'))node.removeAttribute(name);
          }
          if(node.matches('a,button,input,[tabindex]'))node.tabIndex=-1;
          if(node.matches('video')){node.pause();node.autoplay=false;node.removeAttribute('autoplay')}
        });
        this.track.append(copy);
      }
      this.offset=(this.track.scrollLeft||0)%this.width;this.track.scrollLeft=this.offset;
    }
    disconnectedCallback(){
      clearTimeout(this.resumeTimer);cancelAnimationFrame(this.frame);
      this.querySelectorAll('[data-family-post-dialog]').forEach(dialog=>{if(dialog.open)dialog.close()});
      this.controller?.abort();this.controller=null;
      this.resize?.disconnect();this.observer?.disconnect();
      if(this.group){
        this.track.querySelectorAll('[data-family-copy]').forEach(node=>node.remove());
        this.group.replaceWith(...this.group.children);
      }
    }
  });
}

/* Home → product Join Family synchronisation. Render the actual HOME section,
   including its section-specific CSS and all cards/popup settings, not a stale copy. */
(function(){
  if(window.__bvFamilyHomeSyncInstalled)return;
  window.__bvFamilyHomeSyncInstalled=true;
  const inFlight=new WeakMap();
  function fallback(node,message){
    if(!node.isConnected)return;
    const notice=document.createElement('div');
    notice.className='bv-family-home-sync__notice';
    if(window.Shopify?.designMode){
      const label=document.createElement('strong');
      label.textContent='Synchronisation Join Family non disponible';
      notice.append(label);
      const detail=document.createElement('span');
      detail.textContent=message||'La section Join Family sur la Home page est introuvable.';
      notice.append(detail);
    }
    const link=document.createElement('a');
    link.href=node.dataset.homeUrl||'/';
    link.textContent=node.dataset.fallbackLabel||'View JOIN THE FAMILY';
    notice.append(link);
    node.replaceChildren(notice);
  }
  async function synchronize(node){
    if(!node||!node.isConnected||inFlight.has(node)||node.dataset.bvFamilyLoaded==='true')return;
    const aborter=new AbortController();
    inFlight.set(node,aborter);
    try{
      // Request the SAME draft/preview theme, never silently pull the live store.
      const home=new URL(node.dataset.homeUrl||'/',window.location.origin);
      if(home.origin!==window.location.origin)throw Error('Cross-origin source is not allowed');
      // Shopify.theme.id is the actual running preview theme. A missing ID
      // means we cannot guarantee that the fetched homepage is from this theme.
      const themeId=window.Shopify?.theme?.id;
      if(!themeId)throw Error('Impossible de vérifier le thème en aperçu.');
      // Only draft/development themes need a preview context. Never set a preview
      // query parameter in customer-facing requests from the published theme.
      const themeRole=String(window.Shopify?.theme?.role||'').toLowerCase();
      if(themeRole==='unpublished'||themeRole==='development'){
        home.searchParams.set('preview_theme_id',String(themeId));
      }
      home.searchParams.set('bv_family_sync','1');
      const response=await fetch(home.toString(),{
        method:'GET',credentials:'same-origin',cache:'no-store',
        headers:{'Accept':'text/html'},signal:aborter.signal
      });
      if(!response.ok)throw Error('Home page unavailable (HTTP '+response.status+')');
      const html=await response.text();
      // Reject an obvious live/different-theme response even when Shopify
      // cookies or a CDN accidentally ignored preview_theme_id.
      const themeAssign=html.match(/Shopify\.theme\s*=\s*(\{[^;]*\})\s*;/);
      if(themeAssign){
        try{
          const sourceTheme=JSON.parse(themeAssign[1]);
          if(sourceTheme?.id&&String(sourceTheme.id)!==String(themeId))
            throw Error('La Home page retournée utilise un autre thème.');
        }catch(error){
          if(error.message.includes('autre thème'))throw error;
        }
      }
      if(!node.isConnected)return;
      const documentFromHome=new DOMParser().parseFromString(html,'text/html');
      const source=[...documentFromHome.querySelectorAll('belvoir-family[id]')]
        .find(el=>el.id.endsWith('__'+(node.dataset.sourceHomeSection||'join_family')));
      if(!source)throw Error('Home section join_family missing in preview response');
      const sourceWrapper=source.closest('[id^="shopify-section-"]');
      // The section's inline CSS carries all user-selected Home settings.
      if(!sourceWrapper)throw Error('Home section wrapper could not be found');
      // The fetched section might contain a product link / instagram dialog; its
      // exact HTML is used, with no cloning or manual copying of any blocks.
      const cloned=document.importNode(sourceWrapper,true);
      const synced=cloned.querySelector('belvoir-family');
      if(!synced)throw Error('Invalid source section markup');
      // Disable Shopify Theme Editor controls from the nested remote source.
      cloned.removeAttribute('id');
      cloned.querySelectorAll('[data-shopify-editor-block]').forEach(el=>el.removeAttribute('data-shopify-editor-block'));
      cloned.querySelectorAll('[data-shopify-editor-section]').forEach(el=>el.removeAttribute('data-shopify-editor-section'));
      cloned.querySelectorAll('[data-shopify-editor-block]').forEach(el=>el.removeAttribute('data-shopify-editor-block'));
      // Avoid events being intercepted by the product page editor for remote blocks.
      [cloned,...cloned.querySelectorAll('*')].forEach(el=>{
        for(const attribute of [...el.attributes]){
          if(attribute.name.startsWith('data-shopify-editor-'))el.removeAttribute(attribute.name);
        }
      });
      node.replaceChildren(cloned);
      node.dataset.bvFamilyLoaded='true';
      node.removeAttribute('aria-live');
      // The belvoir-family custom element connects automatically on insertion.
    }catch(error){
      if(error.name!=='AbortError'){
        if(window.Shopify?.designMode)console.warn('[Join Family Home Sync]',error);
        fallback(node,error.message);
      }
    }finally{inFlight.delete(node)}
  }
  const boot=(root=document)=>{
    if(root.matches?.('[data-bv-family-home-sync]'))synchronize(root);
    root.querySelectorAll?.('[data-bv-family-home-sync]').forEach(synchronize);
  };
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});
  }else{boot()}
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
